import React from 'react';
import styled from 'styled-components';

import { DataElementContext } from '../../common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';

const ModuleListItemDiv = styled.div((props) => props.$styleText);

export const ModuleListItem = (componentProps) => {
  let props = componentProps;

  const dataElementContext = React.useContext(DataElementContext);
  let isVisible = true;

  [props, isVisible] = processComponentProps(props, dataElementContext);

  if (!isVisible) {
    return null;
  }

  let onClick = null;
  if (props.properties && props.properties.onClick && typeof props.properties.onClick === 'function') {
    onClick = props.properties.onClick;
  } else if (
    componentProps.properties &&
    componentProps.properties.onClick &&
    typeof componentProps.properties.onClick === 'function'
  ) {
    onClick = componentProps.properties.onClick;
  }

  const extraDataProps = {};
  if (props?.properties) {
    Object.keys(props?.properties).forEach((key) => {
      if (key.indexOf('data-') === 0) {
        extraDataProps[key] = props?.properties[key];
      }
    });
  }

  return (
    <ModuleListItemDiv
      className={props.className ?? ''}
      $styleText={props.styleText}
      style={props.style}
      onClick={onClick}
      {...extraDataProps}>
      {componentProps.children}
    </ModuleListItemDiv>
  );
};
